import React, { Component } from 'react'
import { reduxForm, Field, FieldArray } from 'redux-form'

import WrappedInput from 'components/Shared/Forms/WrappedInput'
import { WrappedBindableTextControl } from 'components/Shared/BindableTextControl'
import Modal from 'components/Shared/Modal'
import Button from 'components/Shared/Button'
import Stepper from 'components/Shared/Stepper'

import AuthFields from './AuthFields'
import Endpoints from './Endpoints'
import TestConnection from './TestConnection'
import { validate } from './validation'

export const FORM_NAME = 'addAPIForm'

const NameAndURL = () => {
  return (
    <>
      <Field
        name="name"
        label="Collection Name"
        placeholder="Tasks"
        component={WrappedInput}
        autoComplete="off"
      />
      <Field
        name="baseURL"
        label="API Base URL"
        placeholder="https://api.example.com/v1/tasks"
        component={WrappedBindableTextControl}
        autoComplete="off"
        disableFormulas
        externalAPIField
        enableTestValue
        apiBaseURL
        fromModal
      />
      <FieldArray name="auth" component={AuthFields} />
    </>
  )
}

class AddAPIForm extends Component {
  renderContent() {
    const { step } = this.props

    if (step === 0) {
      return <NameAndURL />
    } else if (step === 1) {
      return <Endpoints />
    } else {
      return <Field name="testResults" component={TestConnection} />
    }
  }

  render() {
    const { handleSubmit, step, handleBack, invalid, isUpdate } = this.props
    const disabled = step === 2 && invalid

    const saveText = isUpdate ? 'Save Collection' : 'Create Collection'

    return (
      <form onSubmit={handleSubmit}>
        <Stepper
          color="orange"
          steps={['Name & URL', 'Endpoints', 'Test Connection']}
          currentStep={step}
        />
        <Modal.Content>{this.renderContent()}</Modal.Content>
        <Modal.Actions>
          <Button text onClick={handleBack} type="button">
            {step === 0 ? 'Cancel' : 'Back'}
          </Button>
          <Button orange type="submit" disabled={disabled}>
            {step === 2 ? saveText : 'Next'}
          </Button>
        </Modal.Actions>
      </form>
    )
  }
}

export default reduxForm({
  form: FORM_NAME,
  validate,
})(AddAPIForm)
